<template>
  <Transition>
    <slot></slot>
  </Transition>
</template>

<script>
// a wrapper for views native transition
// https://vuejs.org/guide/built-ins/transition.html#css-based-transitions
export default {
  name: "TransitionWrapper",
  props: {
    name: String
  }
}
</script>

<style lang="scss">
  // fade in
  .v-enter-from {
    opacity: 0;
    right: -102%;
  }

  .v-enter-to {
    opacity: 1;
    right: 0;
  }

  // fade out
  .v-leave-from {
    opacity: 1;
    right: 0;
  }

  .v-leave-to {
    opacity: 0;
    right: 102%;
  }

  .v-enter-active,
  .v-leave-active {
    left: auto;
    margin: 0 auto;
    position: absolute!important;
    transition: right 0.5s ease, opacity 0.5s ease;
  }
</style>
